<template>
	<div class="container">
		<van-nav-bar style="background: none;" title="通告信息" left-arrow fixed  
        	@click-left="back" >
				<template #right>
					<div class="share_wz_item" @click="sharedInfo">
						<img class="share_wz" src=".././assets/img/share-wz.png">
					</div>
				</template>
       </van-nav-bar>

		<van-row type="flex">
			<van-popup
					v-model="show2"
					position="bottom"
			>
				<van-row>
					<van-col span="24">						
						<div style="display: inline-block;vertical-align: top;margin: 20px 20px;" @click="sharedSession">
							<div style="width: 64px;height: 64px;border-radius: 50%;overflow: hidden;background:#dfdfdf;">
								<img src="../assets/img/share_wechart.png" style="width: 80% !important;margin:10%;">
							</div>
							<div style="width: 64px;height: 20px;line-height:20px;text-align:center;margin: 5px auto;">微信</div>
						</div>			
						<div style="display: inline-block;vertical-align: top;margin: 20px 20px;" @click="shareTimeLine">
							<div style="width: 64px;height: 64px;border-radius: 50%;overflow: hidden;background:#dfdfdf;">
								<img src="../assets/img/share_friends.png" style="width: 80% !important;margin:10%;">
							</div>
							<div style="width: 64px;height: 20px;line-height:20px;text-align:center;margin: 5px auto;">朋友圈</div>
						</div>
					</van-col>
				</van-row>
			</van-popup>
		</van-row>

		<h5 class="titleh5">{{title}}</h5>
        <div v-html="content">{{content}}</div>
	</div>
</template>
<script>
	import { NavBar,Row,Popup } from "vant";
	export default {
		data() {
			return {
				title: '',
				content: '',
				infoId: '',
				show2: false
			}
		},
		components: {
            [NavBar.name]: NavBar,
			[Row.name]: Row,
			[Popup.name]: Popup
        },
        mounted() {
        	let articleId = this.$route.query.infoId;
        	this.infoid = articleId
        	var that = this;
        	this.$api.get(that.jumuc.articleItem, {param: articleId},
            successRes=>{
                if(successRes.success){
                    that.title = successRes.data.jmArticle.title;
                    that.content = successRes.data.jmArticle.content;
                }
            })
        },
		methods: {
			sharedInfo() {
				let that = this
				that.show2 = true
			},
			sharedSession() {
				let that = this
				that.show2 = false;
				Wechat.share({
					message: {
						title: that.title,
						description: that.content,
						thumb: "",
						media: {
							type: Wechat.Type.WEBPAGE,
							webpageUrl: 'http://wx.jumuc.com/#/info/infoId?infoId='+that.infoid
						}
					},
					scene: Wechat.Scene.SESSION
				}, function () {
					that.forwardGetIntegral();
				}, function (reason) {
					that.$toast("分享失败");
				});
			},
			shareTimeLine(){
				let that = this;
				that.show2 = false;
				Wechat.share({
					message: {
						title: that.title,
						description: that.content,
						thumb: "",
						media: {
							type: Wechat.Type.WEBPAGE,
                            webpageUrl: 'http://wx.jumuc.com/#/info/infoId?infoId='+that.infoid
						}
					},
					scene: Wechat.Scene.TIMELINE
				}, function () {
					that.forwardGetIntegral();
				}, function (reason) {
					that.$toast("分享失败");
				});
			},
			forwardGetIntegral(){
				let that = this;
				that.$api.get(that.jumuc.integral.forward,{
							userId:localStorage.getItem("userId"),
							source:2
						},
						successRes=>{
							if(successRes.success){
								that.$toast("分享成功,您获得"+successRes.data.integral+"积分")
							}else{
								that.$toast(successRes.msg);
							}
						})
			},
			back() {
             	history.back();
            },
		}
	}
</script>
<style>
	html{
		width: 100%;
		height: 100vh;
	}
	.van-nav-bar {
	    background-color: #3C6EEB !important;
	}
	.titleh5 {
		text-align: center;
		padding: 15px 0;
		margin-top: 48px;
	}
	img{
		width: 100%;
	}
	.van-nav-bar__right {
		top: 3px;
	}
	.detail-share {
		display: inline-block;
		margin-left: 5px;
		font-size: 26px;
		vertical-align: -2px;
	}
	.share_wz_item {
		width: 50px;
		height: 100%;
		position: absolute;
		top: 0;
		right: -15px;
	}
	.share_wz {
		height: 20px;
		width: 35px;
		margin: 0 auto;
		margin-top: calc(50% - 30px);
	}
</style>